import React, {useState} from "react";
import strapi from "/scripts/apis/strapi/index.js";
import marked from "/scripts/marked/index.js";
import css from "./index.module.scss";
import DefaultLayout from "layouts/default";
import ImageCard from "@/components/imageCard";
import Button from "@/components/button";
import EnterpriseSvg from "/public/images/icons/enterprise.svg";
import Tag from "@/components/tag/index.jsx";
import { StrapiPicture } from "@/components/picture";
import { addToCart } from "@/scripts/utils";
import ProductCard from "@/components/productCard";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { useUser } from "@/scripts/apis/site/useUser";
import ContactForm from "forms/contact";

export default function PurchasePage({}) {
  return <DefaultLayout
    title="Contact Us | Lazy Prompts"
    light
    description="Contact Us"
  >
    <section className={`light ${css.contact}`}>
      <div className="sectionInner">
        <h2>Contact Our Sales Team</h2>
        <p>To request technical support or report a prompt, please open a <a href="https://support.lazyprompts.com">support ticket</a> instead.</p>
        <ContactForm/>
      </div>
    </section>
  </DefaultLayout>;
}
